import { f } from "./addOns-5IZhcbHD.js";
const o = {
  id: "Pick4",
  name: "Pick 4",
  style: {
    colorPrimary: "#ff0000",
    fireball: f
  }
};
export {
  o as default
};
